import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import camelize from '@afosto/utils/string/camelize';

const ErrorMessage = ({ errors, name }) => {
  const intl = useIntl();
  const { type, message } = errors[name] || {};
  let values = {};
  let errorMessage = message;
  const customErrorTypes = [
    'minItems',
    'maxItems',
    'minLength',
    'maxLength',
    'minNumber',
    'maxNumber',
    'moreThanPrice',
  ];

  // The only way to get the values from the validation error into react-intl.
  if (customErrorTypes.includes(type)) {
    const parsedMessage = JSON.parse(message);

    errorMessage = parsedMessage.message ?? '';
    values = parsedMessage.values ?? {};
  }

  return (
    <FormattedMessage
      id={`errors.validation.${type}`}
      defaultMessage={errorMessage}
      description={`Error message for ${name} with type ${type} and message ${errorMessage}`}
      values={{
        target: intl.formatMessage({
          id: `properties.${camelize(name)}`,
          defaultMessage: name,
          description: `Validation property translation for ${name}`,
        }),
        ...values,
      }}
    />
  );
};

ErrorMessage.propTypes = {
  errors: PropTypes.objectOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
    }),
  ),
  name: PropTypes.string.isRequired,
};

ErrorMessage.defaultProps = {
  errors: undefined,
};

export default ErrorMessage;
